import { useEffect } from 'react'

const stack: Array<() => void> = []
let installed = false

function ensureListener() {
  if (installed) return
  installed = true
  window.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Escape') return
      if (stack.length === 0) return
      const top = stack[stack.length - 1]
      e.stopImmediatePropagation()
      top()
    },
    { capture: true },
  )
}

export function useEscapeStack(active: boolean, onClose: () => void) {
  useEffect(() => {
    if (!active) return
    ensureListener()
    stack.push(onClose)
    return () => {
      const idx = stack.lastIndexOf(onClose)
      if (idx >= 0) stack.splice(idx, 1)
    }
  }, [active, onClose])
}
